import React from "react";

export const Success = ({ children }) => {
  return <div className="success">{children}</div>;
};
